import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useChat } from '../../Hook/Chat'
import Layout from '../../Layout'
import Spinner from '../../Components/Spinner'
import { generateItems, get_url_extension } from '../../Utils'
function Index() {
    const {
        id, item,
        connected,
        getRoom, blocked, deleted,
        sendFile, sendMessage,
        loadSendFile,
        modal, setModal,
        room, user,
        setTxt, txt,
        navigate
    } = useChat();

    let name = "کاربر حذف شده";
    let tel = "";
    let image = require('../../assets/image/user.jpg');

    useEffect(() => {
    
        if (connected) {
            getRoom()
        }
    }, [connected, id, item])

    if (!room) {
        return null;
    }

    if (room.room) {
        if (room.room.seler) {
            if (user.id != room.room.seler.id) {
                name = room.room.seler.name;
                tel = room.room.user.mobile;
                if (room.room.seler.meta_data) {
                    image = room.room.seler.meta_data.profile;
                }
            } else {
                if (room.room.user) {
                    name = room.room.user.name;
                    tel = room.room.user.mobile;
                    if (room.room.user.meta_data) {
                        image = room.room.user.meta_data.profile;
                    }
                }
            }
        }
    } else {
        if (room.item) {
            if (room.item.user) {
                name = room.item.user.name;
                tel = room.item.user.mobile;
                if (room.item.user.meta_data) {
                    image = room.item.user.meta_data.profile;
                }
            }
        }
    }
    return (
        <Layout>
            <div className="chat-header col-lg-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div onClick={() => { navigate(-1) }}><i class="far fa-arrow-right"></i></div>
                        <div className="img">
                            <img src={image} alt="" />
                        </div>
                        <div>
                            <div>{name}</div>
                            <div className="light">{room.item && room.item.name}</div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <a href={'tel:' + tel} className="btn" ><i class="far fa-phone-alt"></i></a>
                        <div class="dropdown">
                            <button className="btn dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-ellipsis-v"></i></button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" onClick={blocked}>بلاک کردن</a>
                                <a class="dropdown-item text-danger" onClick={deleted} >حذف گفتگو</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal visable={modal} setVisable={setModal} room={room} />
            <div className="chat-main">
                {room.chats && generateItems(room.chats).map((message, i) => {

                    if (message.type === 'day') {
                        return (
                            <div className="d-flex justify-content-center">
                                <div className="date">
                                    <small>{new Date(message.date).toLocaleDateString('fa')}</small>
                                </div>
                            </div>
                        )

                    }
                    if (message.chat_mimetype == 'file') {
                        return (
                            <div key={i} className={`wraper-message ${message.chat_sender == user.id ? "" : "wraper-left"}`}>
                                <div className="message">
                                    <div>
                                        {get_url_extension(message.chat_message)[1] == 'image' ?
                                            <a href={message.chat_message} download={true} >
                                                <img style={{ width: "100%", height: "250px", objectFit: "cover", borderRadius: 15 }} src={message.chat_message} alt="" />
                                            </a>
                                            :
                                            <>
                                                <i style={{
                                                    fontSize: '22px',
                                                    background: '#fff',
                                                    width: '30px',
                                                    height: '30px',
                                                    display: 'inline-flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: '#333',
                                                    borderRadius: '100%',
                                                    margin: '5px 0px 0px 15px',
                                                }} className='far fa-paperclip'></i>
                                                <a href={message.chat_message} download>دانلود فایل</a>
                                            </>
                                        }
                                    </div>
                                    <div>
                                        <span>{new Date(message.created_at).getHours() + ":" + new Date(message.created_at).getMinutes()}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    return (
                        <div key={i} className={`wraper-message ${message.chat_sender == user.id ? "" : "wraper-left"}`}>
                            <div className="message">
                                {message.chat_message}
                                <div>
                                    <span>{new Date(message.created_at).getHours() + ":" + new Date(message.created_at).getMinutes()}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="chat col-lg-4">
                {(room.room && room.room.room_status == 'block') ?
                    <div className="bg-white p-2">
                        <p className='text-center text-danger'>این گفتگو بسته شده</p>
                    </div>
                    :
                    <>
                        <div className="suggests">
                            <span onClick={() => { sendMessage('سلام وقت بخیر') }} className="sujest">
                                سلام وقت بخیر
                            </span>
                            <span onClick={() => { sendMessage('تخفیف داره؟') }} className="sujest">
                                تخفیف داره؟
                            </span>
                            <span onClick={() => { sendMessage('عکس های بیشتر میفرستید؟') }} className="sujest">
                                عکس های بیشتر میفرستید؟
                            </span>
                            <span onClick={() => { sendMessage('هنوز موجوده؟') }} className="sujest">
                                هنوز موجوده؟
                            </span>

                        </div>
                        <div className="d-flex bg-white p-2">
                            <div className='box-text'>
                                <input placeholder="پیامتان را بنویسید " value={txt} onChange={({ target }) => { setTxt(target.value) }} />
                                {loadSendFile ?
                                    <i><Spinner /></i>
                                    :
                                    <i class="fas fa-camera">
                                        <input type="file" accept="image/png, image/jpeg" onChange={sendFile} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0 }} />
                                    </i>
                                }
                            </div>
                            <div className="btn">
                                <button onClick={() => { sendMessage(txt) }}><i class="fas fa-arrow-left"></i></button>
                            </div>
                        </div>
                    </>
                }
            </div>

        </Layout >
    )
}

const Modal = ({ visable, setVisable, room }) => {
    return (
        <button
            className='chat-modal'
            style={{ display: visable ? "flex" : "none" }}
        >
            <div className="main-modal">
                <div className="center d-flex align-items-center justify-content-center">
                    <i class="fas fa-comment-alt-edit"></i>
                    <span>به این فروشنده امتیاز دهید</span>
                </div>
                <div className="row">
                    <div className="col-7">
                        <Link to={"/Score"} state={{ room }} className="btn blue">
                            امتیاز دهی به فروشنده
                        </Link>
                    </div>
                    <div className="col-5">
                        <button className="btn light" onClick={() => { setVisable(false) }}>
                            انصراف
                        </button>
                    </div>
                </div>
            </div>
        </button>
    )
}

export default Index